import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=d5439326&"
import script from "./project-list.vue?vue&type=script&lang=ts&"
export * from "./project-list.vue?vue&type=script&lang=ts&"
import style0 from "./project-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports